module.exports = __webpack_public_path__ + "static/media/getapp-android.d54da74d.png";